function parseOwnershipValue(song) {
  const rawValue = song.ownership ?? song.ownershipPercentage ?? song.ownershipPct ?? 0;

  if (typeof rawValue === 'number') {
    return rawValue;
  }

  if (typeof rawValue === 'string') {
    const cleanedValue = rawValue.replace(/[^0-9.-]/g, '');
    if (!cleanedValue) return 0;
    return Number(cleanedValue);
  }

  const numericValue = Number(rawValue);
  return Number.isNaN(numericValue) ? 0 : numericValue;
}

export function filterSongsByOwnership(songs, ownershipFilter) {
  if (!ownershipFilter) return songs;

  const normalizedFilter = String(ownershipFilter).trim().toLowerCase();

  return songs.filter((song) => {
    const value = parseOwnershipValue(song);

    if (normalizedFilter === 'high') {
      return value >= 50;
    }

    if (normalizedFilter === 'low') {
      return value < 50;
    }

    return true;
  });
}
